import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import { getTheme, getVars } from '../../global/utils';
import DatePicker from 'react-date-picker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';

const SelectDateWrapper = styled.div`
  margin-bottom: ${props =>
      (props.size === 'xsmall' && getTheme('spacer', 'm')) || getTheme('spacer', 'l')}
    label {
    display: block;
    line-height: 1;
    color: ${getTheme('textColor', 'alt')};
    margin-bottom: ${getTheme('spacer', 'xs')};
    font-size: ${props =>
      (props.size === 'xsmall' && getTheme('fontSize', 'caption')) ||
      (props.size === 'small' && getTheme('fontSize', 'note')) ||
      (props.size === 'medium' && getTheme('fontSize', 'body')) ||
      (props.size === 'large' && getTheme('fontSize', 'title')) ||
      getTheme('fontSize', 'body')};
  }
  .react-date-picker {
    ${props =>
      props.isDisabled &&
      css`
        pointer-events: none;
        opacity: 0.25;
      `};
    &__inputGroup {
      padding: 0;
      line-height: 0.8;
      &__input {
        padding: 0;
      }
      &__year {
        flex-grow: 1;
      }
      &__leadingZero {
        min-width: 1.1em;
      }
    }
    &__button {
      padding: 0;
      margin-left: ${getTheme('spacer', 'xs')};
      color: ${getTheme('black', '_100')};
      .themeDark & {
        color: ${getTheme('textColor', 'baseLight')};
      }
      svg {
        width: 1.5em;
        height: 1.5em;
        margin-top: -0.1em;
      }
    }
    &__calendar {
      width: 280px;
    }
  }
  .react-date-picker__wrapper {
    border: 2px solid ${getTheme('black', '_800')};
    border-radius: ${props =>
      (props.size === 'xsmall' && getTheme('radius', 'xs')) ||
      (props.size === 'small' && getTheme('radius', 's')) ||
      (props.size === 'medium' && getTheme('radius', 'm')) ||
      (props.size === 'large' && getTheme('radius', 'l')) ||
      getTheme('radius', 'm')};

    padding: ${props =>
      (props.size === 'xsmall' && getTheme('padding', 'horizontalXS')) ||
      (props.size === 'small' && getTheme('padding', 'horizontalS')) ||
      (props.size === 'medium' && getTheme('padding', 'horizontalM')) ||
      (props.size === 'large' && getTheme('padding', 'horizontalL')) ||
      getTheme('padding', 'horizontalM')};

    input {
      color: inherit;
    }

    .themeDark & {
      border-color: ${getTheme('black', '_200')};
      color: ${getTheme('textColor', 'baseLight')};
      &:hover {
        border-color: ${getTheme('black', '_400')};
        color: ${getTheme('textColor', 'baseLight')};
      }
      &:active {
        border-color: ${getTheme('black', '_600')};
        color: ${getTheme('textColor', 'baseLight')};
      }
      &:focus {
        box-shadow: 0 0 0 4px ${rgba(getVars('bg', 'active'), 0.25)};
      }
    }
  }

  .react-calendar {
    font-family: inherit;
    margin-top: ${getTheme('spacer', 'xs')};
    border: 2px solid ${getTheme('black', '_800')};
    box-shadow: 0 8px 16px ${rgba(getVars('black', '_50'), 0.1)};
    border-radius: ${props =>
      (props.size === 'xsmall' && getTheme('radius', 'xs')) ||
      (props.size === 'small' && getTheme('radius', 's')) ||
      (props.size === 'medium' && getTheme('radius', 'm')) ||
      (props.size === 'large' && getTheme('radius', 'l')) ||
      getTheme('radius', 'm')};
    .themeDark & {
      background-color: ${getVars('bg', 'dark1')};
      border-color: ${getTheme('black', '_200')};
    }
    &__navigation {
      margin-bottom: 0;
      &__label {
        line-height: 1.1;
      }
    }
    &__tile,
    &__navigation button {
      padding-left: 0;
      padding-right: 0;
      &:hover,
      &:focus {
        background: ${getTheme('black', '_950')};
      }
      &:hover {
        .themeDark & {
          background-color: ${getTheme('black', '_250')};
        }
      }
      &:active {
        .themeDark & {
          border-color: ${getTheme('black', '_350')};
        }
      }
      &:focus {
        .themeDark & {
          background-color: ${getTheme('black', '_250')};
          box-shadow: 0 0 0 4px ${rgba(getVars('bg', 'active'), 0.25)};
        }
      }
      &--hasActive,
      &--hasActive:enabled,
      &--active,
      &--active:enabled {
        background: ${getTheme('active', '_800')};
        .themeDark & {
          background: ${getTheme('active', '_200')};
        }
        &:hover {
          background: ${getTheme('active', '_700')};
        }
        .themeDark &:hover {
          background: ${getTheme('active', '_300')};
        }
        .themeDark &:active {
          background: ${getTheme('active', '_400')};
        }
      }
    }
    &__tile:disabled,
    &__navigation button[disabled] {
      opacity: 0.25;
      cursor: not-allowed;
      .themeDark & {
        background-color: ${getVars('bg', 'dark3')};
      }
    }
    &__month-view__weekdays {
      font-size: 0.6em;
      abbr {
        text-decoration: none;
      }
    }
    &__month-view__days__day--weekend abbr {
      opacity: 0.5;
    }
    button {
      color: inherit;
      font-family: inherit;
    }
  }
`;

class SelectDate extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      isOpen: false,
    };
    this.openCal = this.openCal.bind(this);
    this.closeCal = this.closeCal.bind(this);
  }

  openCal() {
    this.setState({ isOpen: true });
  }

  closeCal() {
    this.setState({ isOpen: false });
  }

  render() {
    let labelWrapper;
    if (this.props.label) {
      labelWrapper = <label>{this.props.label}</label>;
    }
    return (
      <SelectDateWrapper
        size={this.props.size}
        className={this.props.className}
        isDisabled={this.props.isDisabled}
      >
        <span className="icon-before">{this.props.iconBefore}</span>
        {labelWrapper}
        <DatePicker
          onCalendarClose={this.closeCal}
          onClick={this.openCal}
          isOpen={this.state.isOpen}
          clearIcon={null}
          showLeadingZeros={true}
          onChange={this.props.handleChange}
          value={this.props.date}
          minDate={this.props.minDate}
          calendarIcon={<FontAwesomeIcon icon={faCalendarAlt} />}
        ></DatePicker>
      </SelectDateWrapper>
    );
  }
}

export default SelectDate;



// WEBPACK FOOTER //
// ./src/components/forms/SelectDate.js